import { useEffect, useState, useRef } from "react";
import SearchBar from "../Search/SearchBar";
import BorderedButton from "../Buttons/BorderedButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import "react-phone-number-input/style.css";
import { getCountryCallingCode, parsePhoneNumber } from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { getExampleNumber } from "libphonenumber-js";
import examples from "libphonenumber-js/mobile/examples";
import CountrySelectorWithSearch from "../PhoneInput/CountrySelectorWithSearch";
import { useGlobalContext } from "../../Context/GlobalContext";
import { getCustomerList, postCustomerData } from "../../APICalling/APICalling";
import { fetchCountries, findCountryByCodeSync, updateCountryFromCodeSync, getLocalPhoneDigits } from "../../Utils/countryUtils";
import {
	highlightQuery,
	validateEmail,
	getInitials,
	getConsistentColor,
} from "../../Utils/utils";
import {
	isPhoneNumber,
	customerMatchesSearch,
	sortCustomersByRelevance,
	buildCustomerListRequest,
	serializeCustomerListExtraParams,
	normalizeMembershipNumberForApi,
} from "../../Utils/customerSearchUtils";
import {
	setCheckoutCustomerIsPasswordSet,
	storeCheckoutPasswordFlagFromCustomer,
	markCheckoutCustomerPasswordAsSet,
	clearCheckoutCustomerIsPasswordSet,
} from "../../Utils/customerPasswordSession";
import Usericon from "../../Assets/images/username.svg";
import Mobileicon from "../../Assets/images/mobile.svg";
import Emailicon from "../../Assets/images/email.svg";
import styles from "../RightSidebar/rightsidebar.module.css";
import AddCircleIcon from "../Icons/AddCircleIcon";
import PrimiumMemberIcon from "../Icons/PrimiumMemberIcon";
import TrashIcon from "../Icons/TrashIcon";
import TaggingDropdown, { BELOW_12_TAG_OPTION } from "../DropDown/TaggingDropdown/TaggingDropdown";
import { getBookingPreventChanges } from "../../Utils/BookingPreventChanges";

const CustomerSelector = ({
	error,
	setError,
	setApiErrorForCreateBooking,
	handleGetGuestCheckinList,
	handleSelectGuestCheckin,
	selectedGuestCheckin,
	guestCheckinList,
	guestCheckinRemoteList = false,
	onGuestCheckinSearchQueryChange = null,
	onGuestCheckinLoadMore = null,
	guestCheckinHasMore = false,
	guestCheckinLoadingMore = false,
	hideTagging = false,
	customerListUserId = null,
	showMembershipToggle = false,
	preventChangesOverride = null,
	onLockedEditClick = null,
	membershipToggleBlocked = false,
	onMembershipToggleBlocked = null,
}) => {
	const {
		editableBooking,
		setItemData,
		setCustomerData,
		customerData: globalCustomerData,
		setEditedItemData,
		setIsCustomerSelected,
		isCustomerSelected: globalIsCustomerSelected,
		isMembershipApplied,
		setIsMembershipApplied,
		setPaxes,
		setIsCustomerChange,
		setIsMembershipChange,
		setHitTemporaryBookingApi,
		setSelectedGuestCheckin,
		setEditableBooking,
	} = useGlobalContext();

	const { preventChanges: bookingPreventChanges } = getBookingPreventChanges(editableBooking);
	const preventChanges = preventChangesOverride ?? bookingPreventChanges;
	const isMembershipToggleDisabled = preventChanges || membershipToggleBlocked;

	const [isListLoading, setIsListLoading] = useState(false);
	const [listFetchError, setListFetchError] = useState(null);
	const [isCreatingCustomer, setIsCreatingCustomer] = useState(false);
	const [hasMore, setHasMore] = useState(true);

	const [customers, setCustomers] = useState([]);
	const [filteredCustomers, setFilteredCustomers] = useState([]);
	const [selectedCustomer, setSelectedCustomer] = useState(null);
	const [searchQuery, setSearchQuery] = useState("");
	const [showDropdown, setShowDropdown] = useState(false);
	const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);
	const [membership, setMembership] = useState(editableBooking?.user?.membership || 0);
	const [newCustomer, setNewCustomer] = useState({
		firstname: "",
		lastname: "",
		email: "",
		contact_number: "",
		password: "",
		status: 1,
		country_id: null,
	});
	const [errors, setErrors] = useState({});
	const [userHasManuallySelected, setUserHasManuallySelected] = useState(false);
	const [selectedCountry, setSelectedCountry] = useState('SG'); // Country object or ISO code while countries load
	const dropdownRef = useRef(null);
	const currentSearchRef = useRef("");
	const phoneInputWrapperRef = useRef(null);
	const [displayPhoneNumber, setDisplayPhoneNumber] = useState("");
	const filteredCustomersRef = useRef([]);
	const isListLoadingRef = useRef(false);
	const [selectedIndex, setSelectedIndex] = useState(-1);
	const [isKeyboardNavActive, setIsKeyboardNavActive] = useState(false);
	const customerListRef = useRef(null);
	const firstnameInputRef = useRef(null);
	const phoneNumberInputRef = useRef(null);
	const customerCacheRef = useRef({}); // Cache for customer API responses
	const searchDebounceRef = useRef(null);
	const nextCursorRef = useRef(null); // Cursor for next page (cursor-based pagination)
	const customerFetchGenerationRef = useRef(0);
	const lastFetchedSearchRef = useRef("");


	// Ensure editableBooking has a "user" object when it has user_id (e.g. when opening from drag)
	useEffect(() => {
		if (!editableBooking || !setEditableBooking) return;
		const hasUserId = editableBooking.user_id != null;
		const hasUser = editableBooking.user != null && typeof editableBooking.user === "object";
		if (!hasUserId || hasUser) return;

		const userFromBooking = {
			id: editableBooking.user_id,
			name: editableBooking.customer_name ?? "",
			last_name: editableBooking.user?.last_name ?? "",
			email: editableBooking.user?.email ?? null,
			contact_number: editableBooking.mobile_number ?? "",
			membership: editableBooking.membership ?? 0,
			status: editableBooking.user?.status ?? 1,
			created_at: editableBooking.user?.created_at ?? null,
			note: editableBooking.note ?? editableBooking.notes ?? null,
			passport_number: editableBooking.user?.passport_number ?? null,
			is_password_set: editableBooking.user?.is_password_set,
		};

		setCustomerData(userFromBooking);
		storeCheckoutPasswordFlagFromCustomer(userFromBooking);
		setEditableBooking((prev) =>
			prev && prev.user_id != null && !prev.user
				? { ...prev, user: userFromBooking }
				: prev
		);
	}, [editableBooking, setEditableBooking]);


	// console.log("customerData", customerData);
	

	// Warm the shared cache without overwriting a country entered while loading.
	useEffect(() => {
		// The selector displays loading errors and provides retry.
		fetchCountries().catch(() => {});
	}, []);

	// Helper function to update country and country_id when country code is detected
	const updateCountryFromCode = (countryCode) => {
		updateCountryFromCodeSync(
			countryCode,
			setSelectedCountry,
			setNewCustomer,
			'country_id'
		);
	};

	// Helper function to find country object by country code (using shared utility)
	const findCountryByCode = (countryCode) => {
		return findCountryByCodeSync(countryCode);
	};

	const resolveCountryId = (country = selectedCountry) => {
		if (country && typeof country === "object" && country.id != null) {
			return country.id;
		}
		const code =country && typeof country === "object" ? country.code : (country || "SG");
		return findCountryByCodeSync(code)?.id ?? null;
	};

	const applyDefaultCountry = (setCustomerState = true) => {
		const defaultCountry = findCountryByCodeSync("SG");
		setSelectedCountry(defaultCountry || "SG");
		if (setCustomerState) {
			setNewCustomer((prev) => ({
				...prev,
				country_id: defaultCountry?.id ?? null,
			}));
		}
		return defaultCountry;
	};

	// Get placeholder based on selected country using libphonenumber-js
	const getMobilePlaceholder = (country) => {
		const countryCode = country && typeof country === 'object' ? country.code : country;
		if (!countryCode) return 'Mobile number';
		try {
			// Get example number for the country
			const exampleNumber = getExampleNumber(countryCode, examples);
			if (exampleNumber) {
				// Format the example number and remove country code
				const formatted = exampleNumber.formatNational();
				return formatted || 'Mobile number';
			}
		} catch (error) {
			// console.log('Error getting example number:', error);
		}
		return 'Mobile number';
	};

	// Clear display when contact number is cleared. Do not rewrite display from
	// nationalNumber while typing — that caused digits (e.g. leading zeros) to be trimmed.
	// Country detection from full numbers is handled on paste / country selector.
	useEffect(() => {
		if (showNewCustomerForm && !newCustomer.contact_number) {
			setDisplayPhoneNumber("");
		}
	}, [newCustomer.contact_number, showNewCustomerForm]);

	// Hide default country selector when form is shown - using ref-based approach
	useEffect(() => {
		if (!showNewCustomerForm) return;

		const hideDefaultCountrySelector = () => {
			if (!phoneInputWrapperRef.current) return;

			// Find all PhoneInput elements and hide their country selectors
			const wrapper = phoneInputWrapperRef.current;
			const phoneInputElements = wrapper.querySelectorAll('.PhoneInput');

			phoneInputElements.forEach(phoneInput => {
				// Hide ALL select elements (country selector) - PhoneInput should only have input, not select
				const selects = phoneInput.querySelectorAll('select');
				selects.forEach(select => {
					// Hide any select element that's not our custom component
					select.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; width: 0 !important; height: 0 !important; position: absolute !important; left: -9999px !important; pointer-events: none !important; margin: 0 !important; padding: 0 !important; border: none !important;';
				});

				// Hide country icon (any element with CountryIcon in class name)
				const icons = phoneInput.querySelectorAll('[class*="CountryIcon"], [class*="PhoneInputCountry"]');
				icons.forEach(icon => {
					// Only hide if it's not part of our custom CountrySelectorWithSearch component
					if (!icon.closest('[class*="countrySelectorContainer"]')) {
						icon.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; width: 0 !important; height: 0 !important;';
					}
				});

				// Hide dropdown (any element with CountryDropdown in class name)
				const dropdowns = phoneInput.querySelectorAll('[class*="CountryDropdown"], [class*="PhoneInputCountryDropdown"]');
				dropdowns.forEach(dropdown => {
					// Only hide if it's not our custom CountrySelectorWithSearch dropdown
					if (!dropdown.closest('[class*="countrySelectorContainer"]')) {
						dropdown.style.cssText = 'display: none !important;';
					}
				});
			});
		};

		// Run multiple times to catch dynamically rendered elements
		hideDefaultCountrySelector();
		const timers = [50, 100, 200, 500, 1000].map(delay =>
			setTimeout(hideDefaultCountrySelector, delay)
		);

		return () => {
			timers.forEach(timer => clearTimeout(timer));
		};
	}, [showNewCustomerForm, newCustomer.contact_number]);

	useEffect(() => {
		if (editableBooking && !userHasManuallySelected) {
			const bookingUser = editableBooking.user || {};
			const normalizedNotes =bookingUser?.notes ??bookingUser?.note ??editableBooking?.users_notes ??editableBooking?.notes ??editableBooking?.note ??"";
			setSelectedCustomer((prev) => {
				const nextCustomer = {...bookingUser,notes: normalizedNotes,note: normalizedNotes,
				};
				if (
					prev &&
					Number(prev?.id) === Number(nextCustomer?.id) &&
					(prev?.notes ?? "") === (nextCustomer?.notes ?? "") &&
					(prev?.note ?? "") === (nextCustomer?.note ?? "") &&
					Number(prev?.membership ?? 0) === Number(nextCustomer?.membership ?? 0)
				) {
					return prev;
				}
				return nextCustomer;
			});
		}
	}, [editableBooking, userHasManuallySelected]);

	useEffect(() => {
		if (selectedCustomer) {
			setCustomerData(selectedCustomer);
			storeCheckoutPasswordFlagFromCustomer(selectedCustomer);
		}
	}, [selectedCustomer, setCustomerData]);

	// Initialize membership toggle state in edit based on selected/booking user
	useEffect(() => {
		if (editableBooking && !userHasManuallySelected) {
			const applied = Number(selectedCustomer?.membership ?? editableBooking?.user?.membership ?? 0) === 1;
			setMembership(applied ? 1 : 0);
			setIsMembershipApplied(applied);
		}
	}, [editableBooking, userHasManuallySelected, selectedCustomer?.membership, setIsMembershipApplied]);

	useEffect(() => {
		return undefined;
	}, []);

	useEffect(() => {
		return () => {
			if (searchDebounceRef.current) {
				clearTimeout(searchDebounceRef.current);
			}
		};
	}, []);

	// Sync refs with state changes
	useEffect(() => {
		filteredCustomersRef.current = filteredCustomers;
	}, [filteredCustomers]);

	useEffect(() => {
		isListLoadingRef.current = isListLoading;
	}, [isListLoading]);

	// Auto-scroll to selected item
	useEffect(() => {
		if (selectedIndex >= 0 && customerListRef.current) {
			const selectedEl = customerListRef.current.querySelector(
				`[data-index="${selectedIndex}"]`
			);
			selectedEl?.scrollIntoView({ behavior: 'auto', block: 'nearest' });
		}
	}, [selectedIndex]);

	// Listen for customer updates from CustomerDetailsModal
	useEffect(() => {
		const handleCustomerUpdated = (event) => {
			const updatedCustomer = event.detail?.customer;
			if (updatedCustomer && Number(selectedCustomer?.id) === Number(updatedCustomer.id)) {
				const membershipStatus = String(
					updatedCustomer?.membership_detail?.status_label ??
					updatedCustomer?.membership_detail?.status ?? ''
				).trim().toLowerCase();
				const membership = membershipStatus
					? Number(['active', '1'].includes(membershipStatus))
					: Number(updatedCustomer.membership === true || Number(updatedCustomer.membership) === 1);
				const normalizedCustomer = { ...updatedCustomer, membership };
				const latestNotes =updatedCustomer?.note ??updatedCustomer?.notes ??updatedCustomer?.users_notes;
				// Update the selected customer with the new data
				setSelectedCustomer({
					...normalizedCustomer,
					...(latestNotes !== undefined ? { notes: latestNotes, note: latestNotes } : {}),
				});
				setCustomerData({
					...normalizedCustomer,
					...(latestNotes !== undefined ? { notes: latestNotes, note: latestNotes, users_notes: latestNotes } : {}),
				});
				if (updatedCustomer.is_password_set === true || updatedCustomer.is_password_set === 1 || updatedCustomer.is_password_set === '1') {
					markCheckoutCustomerPasswordAsSet(updatedCustomer.id);
				} else {
					storeCheckoutPasswordFlagFromCustomer(updatedCustomer);
				}
				// Update membership if it changed
				setMembership(membership);
				setIsMembershipApplied(membership === 1);
				// Update itemData with new customer info
				setItemData((prev) => ({
					...prev,
					customer: updatedCustomer.id,
					membership,
				}));
			}
		};

		window.addEventListener('customerUpdated', handleCustomerUpdated);
		return () => {
			window.removeEventListener('customerUpdated', handleCustomerUpdated);
		};
	}, [selectedCustomer?.id, setCustomerData, setIsMembershipApplied, setItemData]);

	useEffect(() => {
		const handleCustomerNotesUpdated = (event) => {
			const updatedCustomerId = event?.detail?.customerId;
			const updatedNotes = event?.detail?.notes ?? "";
			if (!updatedCustomerId) return;
			if (Number(selectedCustomer?.id) !== Number(updatedCustomerId)) return;
			setSelectedCustomer((prev) =>
				prev? {...prev,notes: updatedNotes,note: updatedNotes,}: prev
			);
			setCustomerData((prev) =>
				prev && Number(prev?.id) === Number(updatedCustomerId)? { ...prev, notes: updatedNotes, note: updatedNotes, users_notes: updatedNotes }: prev
			);
		};

		window.addEventListener('customerNotesUpdated', handleCustomerNotesUpdated);
		return () => {
			window.removeEventListener('customerNotesUpdated', handleCustomerNotesUpdated);
		};
	}, [selectedCustomer?.id, setCustomerData]);


	useEffect(() => {
		if (
			editableBooking &&
			editableBooking.user_id &&
			!userHasManuallySelected
		) {
			setIsCustomerSelected(true);
			setItemData((prev) => ({
				...prev,
				// customer: foundCustomer.user_id,
				customer: selectedCustomer?.id,
				membership: selectedCustomer?.membership || membership,
			}));
		}
	}, [editableBooking, userHasManuallySelected, membership, setIsCustomerSelected, selectedCustomer?.id, selectedCustomer?.membership, setItemData]);

	// Initialize selectedCustomer from global context when available
	useEffect(() => {
		if (globalCustomerData && !selectedCustomer && globalIsCustomerSelected) {
			setSelectedCustomer(globalCustomerData);
			setMembership(Number(globalCustomerData.membership || 0));
			// Preserve isMembershipApplied — remounting (e.g. product checkout after payment)
			// must not reset the user's membership discount toggle choice.
			setUserHasManuallySelected(true);
		}
	}, [globalCustomerData, globalIsCustomerSelected, selectedCustomer]);

	// ✅ Initialize customer-level guest checkin from editableBooking in edit mode
	useEffect(() => {
		if (editableBooking && editableBooking.booking_item && setSelectedGuestCheckin) {
			const isUnder12CheckinExempt = (service) => (
				(
					service?.checkin_required === false ||
					service?.checkin_required === 0 ||
					service?.checkin_required === "0" ||
					service?.checkin_required === "false"
				) &&
				service?.checkin_exempt_reason === "under_12"
			);

			// Only initialize if not already set
			setSelectedGuestCheckin((prev) => {
				if (prev?.customer) {
					return prev; // Already set, don't override
				}
				
				const bookingItems = editableBooking.booking_item;
				if (typeof bookingItems === "object") {
				const bookingItemEntries = Object.entries(bookingItems);
				// Check first entry (customer-level services)
				if (bookingItemEntries.length > 0) {
					const [, services] = bookingItemEntries[0];
						if (Array.isArray(services) && services.length > 0) {
							const firstService = services[0];
							if (Number(firstService.below_12) === 1 || isUnder12CheckinExempt(firstService)) {
								return {
									...prev,
									'customer': {
										item: BELOW_12_TAG_OPTION,
									}
								};
							}
							if (firstService.guest_checkin_id && firstService.guest_first_name) {
								const guestCheckinName = `${firstService.guest_first_name} ${firstService.guest_checkin_last_name || ''}`.trim();
								if (guestCheckinName) {
									// Parse guest_checkin_name into first_name and last_name
									const nameParts = guestCheckinName.split(/\s+/);
									const firstName = nameParts[0] || '';
									const lastName = nameParts.slice(1).join(' ') || '';
									
									return {
										...prev,
										'customer': {
											item: {
												id: firstService.guest_checkin_id,
												first_name: firstName,
												last_name: lastName,
												name: firstName, // For backward compatibility
												lastname: lastName, // For backward compatibility
											}
										}
									};
								}
							}
						}
					}
				}
				return prev;
			});
		}
	}, [editableBooking, setSelectedGuestCheckin]);


	// Helper function to parse name into firstname and lastname
	const parseName = (nameStr) => {
		if (!nameStr || !nameStr.trim()) {
			return { firstname: '', lastname: '' };
		}
		const trimmed = nameStr.trim();
		const parts = trimmed.split(/\s+/);
		if (parts.length === 1) {
			return { firstname: parts[0], lastname: '' };
		}
		// First part is firstname, rest is lastname
		const firstname = parts[0];
		const lastname = parts.slice(1).join(' ');
		return { firstname, lastname };
	};


	// GET CUSTOMER LIST START
	const resetCustomerListState = () => {
		setCustomers([]);
		setFilteredCustomers([]);
		filteredCustomersRef.current = [];
		setHasMore(true);
		nextCursorRef.current = null;
		lastFetchedSearchRef.current = "";
	};

	const fetchCustomerList = async (searchText = "", cursor = null) => {
		setShowDropdown(true);
		setIsListLoading(true);
		setListFetchError(null);
		isListLoadingRef.current = true;

		// Store the search text for this API call
		const searchForThisCall = searchText.trim();
		const isFirstPage = !cursor;

		const listExtraParams =
			customerListUserId != null && customerListUserId !== ""
				? { user: customerListUserId }
				: {};

		// Generate cache key (cursor-based, includes extra payload fields)
		const cacheKey = `${searchForThisCall}_${cursor || "first"}_${serializeCustomerListExtraParams(listExtraParams)}`;
		
		const fetchGeneration = isFirstPage ? ++customerFetchGenerationRef.current : null;
		const shouldApplyResults = () => {
			if (currentSearchRef.current.trim() !== searchForThisCall) return false;
			if (isFirstPage && fetchGeneration !== customerFetchGenerationRef.current) return false;
			return true;
		};

		// Check cache first
		if (customerCacheRef.current[cacheKey]) {
			if (!shouldApplyResults()) {
				setIsListLoading(false);
				isListLoadingRef.current = false;
				return;
			}

			setListFetchError(null);
			const cachedData = customerCacheRef.current[cacheKey];
			
			// Process cached data similar to API success
			const newCustomers = cachedData.clients || [];
			
			// Combine/Set customers based on page
			setCustomers((prev) => {
				const combined = isFirstPage ? newCustomers : [...prev, ...newCustomers];
				
				if (searchForThisCall) {
					const filtered = combined.filter(customer =>
						customer && customerMatchesSearch(customer, searchForThisCall)
					);
					return sortCustomersByRelevance(filtered, searchForThisCall);
				}
				return combined;
			});

			setFilteredCustomers((prev) => {
				const combined = isFirstPage ? newCustomers : [...prev, ...newCustomers];
				let finalList = combined;
				if (searchForThisCall) {
					const filtered = combined.filter(customer =>
						customer && customerMatchesSearch(customer, searchForThisCall)
					);
					finalList = sortCustomersByRelevance(filtered, searchForThisCall);
				}
				filteredCustomersRef.current = finalList;
				return finalList;
			});

			// Handle cursor-based pagination from cache
			const pagination = cachedData.pagination;
			const hasMorePages = pagination?.hasMorePages ?? (pagination?.currentPage < pagination?.lastPage);
			setHasMore(!!hasMorePages);
			nextCursorRef.current = pagination?.nextCursor ?? null;
			lastFetchedSearchRef.current = searchForThisCall;

			setIsListLoading(false);
			isListLoadingRef.current = false;
			return; // Exit after using cache
		}

		const { item } = buildCustomerListRequest(searchForThisCall, cursor, listExtraParams);

		try {
			const response = await getCustomerList(item);
			
			if (response?.data?.data?.list) {
				// Cache the response data
				customerCacheRef.current[cacheKey] = response.data.data.list;
			}

			const newCustomers = response.data.data.list.clients || [];

			// Ignore stale responses when the user has typed a newer query
			if (!shouldApplyResults()) {
				return;
			}

			// Filter customers that actually match the EXACT search query, then sort by relevance
			let processedCustomers = newCustomers;
			if (searchForThisCall) {
				// Strict client-side filtering: only include customers that match the exact search
				processedCustomers = newCustomers.filter(customer =>
					customer && customerMatchesSearch(customer, searchForThisCall)
				);
				// Then sort by relevance
				processedCustomers = sortCustomersByRelevance(processedCustomers, searchForThisCall);
			}

			setCustomers((prev) => {
				const combined = isFirstPage ? processedCustomers : [...prev, ...processedCustomers];
				// Re-filter and re-sort the entire combined list if search text exists
				if (searchForThisCall) {
					const filtered = combined.filter(customer =>
						customer && customerMatchesSearch(customer, searchForThisCall)
					);
					return sortCustomersByRelevance(filtered, searchForThisCall);
				}
				return combined;
			});

			setFilteredCustomers((prev) => {
				const combined = isFirstPage ? processedCustomers : [...prev, ...processedCustomers];
				// Re-filter and re-sort the entire combined list if search text exists
				let finalList = combined;
				if (searchForThisCall) {
					const filtered = combined.filter(customer =>
						customer && customerMatchesSearch(customer, searchForThisCall)
					);
					finalList = sortCustomersByRelevance(filtered, searchForThisCall);
				}
				// Update ref with latest filtered customers
				filteredCustomersRef.current = finalList;
				return finalList;
			});

			// Cursor-based pagination logic
			const pagination = response.data.data.list.pagination;
			const hasMorePages = pagination?.hasMorePages ?? (pagination?.currentPage < pagination?.lastPage);
			setHasMore(!!hasMorePages);
			nextCursorRef.current = pagination?.nextCursor ?? null;
			lastFetchedSearchRef.current = searchForThisCall;
		} catch (err) {
			console.error("Error fetching data:", err);
			const currentSearch = currentSearchRef.current.trim();
			if (currentSearch === searchForThisCall) {
				setListFetchError("Network error. Please check your internet connection and try again.");
			}
		} finally {
			setIsListLoading(false);
			isListLoadingRef.current = false;
		}
	};
	// GET CUSTOMER LIST END


	// Field-wise Validation
	const validateField = (name, value) => {
		let error = "";
		switch (name) {
			case "firstname":
				if (!value.trim()) error = "Required";
				// else if (!/^[A-Za-z\s'-]+$/.test(value))
				// 	error = "Only letters, hyphens and apostrophes allowed";
				break;
			case "lastname":
				// Last name is optional, no validation needed
				break;
			case "email":
				if (!value.trim()) {
					error = "";
				} else if (!validateEmail(value)) {
					error = "Invalid email format";
				}
				break;
			case "contact_number":
				if (!value) error = "Mobile number is required";
				else if (!isValidPhoneNumber(value))
					error = "Invalid phone number";
				break;
			default:
				break;
		}
		setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
		return error === "";
	};

	const validateForm = () => {
		const firstnameValid = validateField("firstname", newCustomer.firstname);
		// Last name is optional, no validation needed
		const mobileValid = validateField("contact_number", newCustomer.contact_number);
		// const emailValid = validateField("email", newCustomer.email);
		// return firstnameValid && lastnameValid && emailValid && mobileValid;
		return firstnameValid && mobileValid;
	};

	// SEARCH START 
	const handleCustomerSearch = (e) => {
		const query = e.target.value;
		setSearchQuery(query);

		// Update the current search ref immediately
		currentSearchRef.current = query;

		// Reset keyboard selection when search changes
		setSelectedIndex(-1);
		setIsKeyboardNavActive(false);

		if (searchDebounceRef.current) {
			clearTimeout(searchDebounceRef.current);
		}

		searchDebounceRef.current = setTimeout(() => {
			const latestQuery = currentSearchRef.current;

			// Clear previous results when search changes
			resetCustomerListState();

			// Always fetch from API for fresh search results
			fetchCustomerList(latestQuery);
		}, 300);
	};
	// SEARCH END

	// Handle keyboard navigation in customer list
	const handleSearchKeyDown = (e) => {
		const hasQuery = !!searchQuery?.trim();
		const displayedCustomers = !hasQuery
			? customers
			: filteredCustomers.filter(c => c && customerMatchesSearch(c, searchQuery));
		const addClientIndex = hasQuery ? displayedCustomers.length : -1;
		const maxIndex = hasQuery ? displayedCustomers.length : displayedCustomers.length - 1;

		// Arrow Down/Up navigation
		if (e.key === 'ArrowDown' && displayedCustomers.length > 0) {
			e.preventDefault();
			setIsKeyboardNavActive(true);
			setSelectedIndex(prev => Math.min(prev + 1, maxIndex));
		} else if (e.key === 'ArrowUp' && displayedCustomers.length > 0) {
			e.preventDefault();
			setIsKeyboardNavActive(true);
			setSelectedIndex(prev => Math.max(prev - 1, 0));
		} 
		// Enter key - select highlighted customer or create new
		else if (e.key === 'Enter') {
			e.preventDefault();
			
			// Select highlighted customer
			if (selectedIndex >= 0 && displayedCustomers[selectedIndex]) {
				handleSelectCustomer(displayedCustomers[selectedIndex].id);
				setSelectedIndex(-1);
				return;
			}
			// Select "Add Client" when highlighted
			if (hasQuery && selectedIndex === addClientIndex) {
				autoFillNewCustomerForm(searchQuery);
				setSelectedIndex(-1);
				return;
			}

			// Create new customer if no results
			const query = searchQuery.trim();
			if (!query) return;

			let attempts = 0;
			const checkForResults = () => {
				if (currentSearchRef.current.trim() !== query) return;
				
				const exactMatches = filteredCustomersRef.current.filter(c => 
					c && customerMatchesSearch(c, query)
				);

				if (isListLoadingRef.current && attempts++ < 10) {
					setTimeout(checkForResults, 300);
				} else if (exactMatches.length === 0) {
					autoFillNewCustomerForm(query);
				}
			};
			checkForResults();
		}
	};

	// Helper function to auto-fill new customer form based on search query
	const autoFillNewCustomerForm = (query) => {
		// Determine if query is a phone number or name
		if (isPhoneNumber(query)) {
			// It's a phone number - auto-fill contact_number
			let phoneNumber = query.trim();
			let parsedCountry = selectedCountry && typeof selectedCountry === 'object' 
				? selectedCountry.code 
				: (selectedCountry || 'SG');
			let parsedDisplayNumber = '';
			let formattedPhoneNumber = '';

			// Try to parse the phone number
			// First, try as-is if it starts with +
			if (phoneNumber.startsWith('+')) {
				try {
					const parsed = parsePhoneNumber(phoneNumber);
					if (parsed && parsed.country) {
						parsedCountry = parsed.country;
						parsedDisplayNumber = getLocalPhoneDigits(phoneNumber, parsed);
						formattedPhoneNumber = phoneNumber;
					}
				} catch (e) {
					// Parsing failed, will try with country code below
				}
			}

			// If parsing failed or number doesn't start with +, try adding country code
			if (!formattedPhoneNumber) {
				const digitsOnly = phoneNumber.replace(/\D/g, '');
				// Add country code and try parsing
				const countryCode = selectedCountry && typeof selectedCountry === 'object' 
					? selectedCountry.dial_code 
					: getCountryCallingCode(selectedCountry || 'SG');
				const withCountryCode = `+${countryCode}${digitsOnly}`;

				try {
					const parsed = parsePhoneNumber(withCountryCode);
					if (parsed && parsed.country) {
						parsedCountry = parsed.country;
						parsedDisplayNumber = digitsOnly;
						formattedPhoneNumber = withCountryCode;
					} else {
						// Fallback: use the number with country code
						formattedPhoneNumber = withCountryCode;
						parsedDisplayNumber = digitsOnly;
					}
				} catch (e) {
					// If all parsing fails, use default country code
					formattedPhoneNumber = withCountryCode;
					parsedDisplayNumber = digitsOnly;
				}
			}

			// Update state - find country object and update country_id
			updateCountryFromCode(parsedCountry);
			const countryObject = findCountryByCode(parsedCountry);
			setDisplayPhoneNumber(parsedDisplayNumber);
			setNewCustomer(prev => ({
				...prev,
				contact_number: formattedPhoneNumber,
				country_id: countryObject?.id || null,
				firstname: '',
				lastname: '',
			}));
		} else {
			// It's a name - auto-fill firstname and lastname
			const { firstname, lastname } = parseName(query);

			const defaultCountry = findCountryByCodeSync("SG");
			setNewCustomer(prev => ({
				...prev,
				firstname: firstname,
				lastname: lastname,
				contact_number: '',
				country_id: defaultCountry?.id ?? null,
			}));

			// Clear phone number fields
			setDisplayPhoneNumber('');
			setSelectedCountry(defaultCountry || 'SG');
		}

		// Open new customer form
		setShowNewCustomerForm(true);
		setShowDropdown(false);
		setIsCustomerSelected(false);

		// Auto-focus on the empty field after form opens
		setTimeout(() => {
			if (isPhoneNumber(query)) {
				// Phone was auto-filled, focus on name
				firstnameInputRef.current?.focus();
			} else {
				// Name was auto-filled, focus on phone
				phoneNumberInputRef.current?.focus();
			}
		}, 100);
	};

	// ADD NEW CUSTOMER START
	const handleAddButtonClick = () => {
		setShowNewCustomerForm(true);
		setSearchQuery("");
		currentSearchRef.current = "";
		setShowDropdown(false);
		setSelectedCustomer();
		setIsCustomerSelected(false);
		applyDefaultCountry(true);
	};
	// ADD NEW CUSTOMER END

	// DELETE CUSTOMER START
	const handleDeleteCustomer = () => {
		setSelectedCustomer(null);
		setMembership(0);
		setIsMembershipApplied(false);
		setIsCustomerSelected(false);
		setCustomerData({});
		clearCheckoutCustomerIsPasswordSet();
		const defaultCountry = findCountryByCodeSync("SG");
		setNewCustomer({
			firstname: "",
			lastname: "",
			email: "",
			contact_number: "",
			membership: 0,
			country_id: defaultCountry?.id ?? null,
		});
		setErrors({});
		setSearchQuery("");
		currentSearchRef.current = "";
		resetCustomerListState();
		setShowDropdown(false);
		setSelectedIndex(-1);
		setIsKeyboardNavActive(false);
		setUserHasManuallySelected(true); // 👈 important
		// Preserve paxes and their services when removing the primary customer
		setSelectedCountry(defaultCountry || "SG");
		// Clear the customer guest check-in tag when deleting customer
		if (handleSelectGuestCheckin) {
			handleSelectGuestCheckin(null, 'customer');
		}
		setItemData((prev) => ({
			...prev,
			customer: null,
		}));
	};
	// DELETE CUSTOMER END

	const handleCreateCustomer = async (e) => {
		e.preventDefault();
		if (!validateForm()) return;
		setIsCreatingCustomer(true);
		setError("");
		setApiErrorForCreateBooking?.("");
		const { firstname, lastname, contact_number, email } = newCustomer;
		const loggedInUserId = Number(localStorage.getItem('user_id'));
		try {
			await fetchCountries().catch(() => null);
			const countryCode = typeof selectedCountry === 'object' ? selectedCountry?.code : selectedCountry;
			const country = findCountryByCodeSync(countryCode);
			if (!country?.id) {
				setErrors((prev) => ({ ...prev, contact_number: 'Unable to load the selected country. Please try again.' }));
				return;
			}
			const customerPayload = {
				name: firstname,
				last_name: lastname,
				email: email,
				contact_number: contact_number,
				membership: 0,
				panel: "outlet",
				password: "qw21QW@!",
				gender: "",
				status: 1,
				country_id: country.id,
				created_by: loggedInUserId,
				created_via : "outlet"
			};
			const response = await postCustomerData(customerPayload);
			const isSuccess = response?.data?.success ?? response?.success;

			if (isSuccess) {
				const customerResult = response?.data?.data ?? response?.data;
				const addedCustomer = {
					...customerResult,
					membership: Number(customerResult?.membership ?? customerPayload.membership ?? 0),
				};
				setSelectedCustomer(addedCustomer);
				setIsCustomerSelected(true);
				setMembership(Number(addedCustomer.membership));
				setCustomerData(addedCustomer);
				storeCheckoutPasswordFlagFromCustomer(addedCustomer);
				customerCacheRef.current = {}; // Clear cache on new customer creation
				setShowNewCustomerForm(false);
				setShowDropdown(false);
				setHitTemporaryBookingApi(true);
				// ✅ FIXED: Don't clear services when customer is created to preserve time
				// setSelectedServices([]);
				setItemData((prev) => ({
					...prev,
					customer: addedCustomer.id,
					membership: Number(addedCustomer.membership),
				}));
				if (editableBooking) {
					setEditedItemData((prev) => ({
						...prev,
						customer: addedCustomer.id,
						customer_name: addedCustomer?.name,
						customer_lastname: addedCustomer?.last_name ?? addedCustomer?.lastname,
						customer_email: addedCustomer?.email,
						mobile_number: addedCustomer?.contact_number,
						membership: Number(addedCustomer.membership),
					}));
				}
				// setCustomerSelected(true);

				const defaultCountry = findCountryByCodeSync("SG");
				setNewCustomer({
					firstname: "",
					lastname: "",
					email: "",
					contact_number: "",
					password: "",
					status: 1,
					membership: 0,
					country_id: defaultCountry?.id ?? null,
				});
				setSelectedCountry(defaultCountry || 'SG');
				setDisplayPhoneNumber("");
				setIsMembershipApplied(false);
				setUserHasManuallySelected(true);
				setIsCustomerChange(true);
				setError("");
				setApiErrorForCreateBooking?.("");
			}
			else {
				console.error("Contact details send failed:", response);
				const message =response?.message || response?.data?.message || "Failed to create customer. Please try again.";
				setApiErrorForCreateBooking?.(message);
			}
		} catch (error) {
			console.error("Error submitting Contact details:", error);
			const message =error?.response?.data?.message || error?.message || "Failed to create customer. Please try again.";
			setApiErrorForCreateBooking?.(message);
		} finally {
			setIsCreatingCustomer(false);
		}
	};



	// SELECT CUSTOMER START 
	const handleSelectCustomer = (customerId) => {
		const selectedCustomer = customers.find((c) => c?.id === customerId);
		if (!selectedCustomer) return;

		setSelectedCustomer(selectedCustomer);
		setIsCustomerSelected(true);
		setMembership(Number(selectedCustomer.membership));
		setIsMembershipApplied(selectedCustomer.membership === 1 ? true : false);
		setCustomerData(selectedCustomer);
		storeCheckoutPasswordFlagFromCustomer(selectedCustomer);
		setSearchQuery("");
		currentSearchRef.current = "";
		resetCustomerListState();
		setShowDropdown(false);
		setHitTemporaryBookingApi(true);
		setUserHasManuallySelected(true);
		setError("");
		// Preserve paxes and their services when selecting a new primary customer
		setItemData((prev) => ({
			...prev,
			// customer: selectedCustomer.user_id,
			customer: selectedCustomer?.id,
			membership: Number(selectedCustomer.membership),
		}));
		// Also update editedItemData if this is an edit operation
		if (editableBooking) {
			setEditedItemData((prev) => ({
				...prev,
				customer: selectedCustomer.id,
				customer_name: selectedCustomer?.name,
				customer_lastname: selectedCustomer?.lastname,
				customer_email: selectedCustomer.email,
				mobile_number: selectedCustomer?.contact_number,
				membership: Number(selectedCustomer.membership),
			}));
		}
		setIsCustomerChange(true);
	};
	// SELECT CUSTOMER END







	const customerNotes =selectedCustomer?.notes ??selectedCustomer?.note ??selectedCustomer?.users_notes ??"";

	const highlightTerm = searchQuery.trim();
	const renderSearchHighlight = (text) =>
		highlightTerm ? highlightQuery(text ?? "", highlightTerm) : (text ?? "");

	const isCustomerBlocked = (customer) =>
		customer?.is_blocked === true || Number(customer?.is_blocked) === 1;

	const renderCustomerMembershipLabel = (customer) => {
		const membershipNumber = normalizeMembershipNumberForApi(customer?.membership_number);
		if (!membershipNumber) return null;

		return (
			<>
				{" "}
				{renderSearchHighlight(`(#${membershipNumber})`)}
			</>
		);
	};

	const renderCustomerBlockedLabel = (customer) => {
		if (!isCustomerBlocked(customer)) return null;
		return <> (Blocked)</>;
	};

	return (
		<>
			{!showNewCustomerForm && !selectedCustomer && (
				<div>
					<div className={`${styles.customerSearch} ${styles.newCustomerCreate}`}>
						<SearchBar
							placeholder="Search or create customer"
							value={searchQuery}
							onChange={handleCustomerSearch}
							onKeyDown={handleSearchKeyDown}
							onFocus={() => {
								setShowDropdown(true);
								if (searchQuery?.trim() || isListLoading) return;

								const needsFullList =
									customers.length === 0 || lastFetchedSearchRef.current !== "";

								if (needsFullList) {
									resetCustomerListState();
									currentSearchRef.current = "";
									fetchCustomerList("");
								}
							}}
							className={styles.sidebarSearch}
							iconClassName={styles.rightbarSearch}
							searchBarClassName={styles.customerSearchBar}
						/>
						<button onClick={handleAddButtonClick} className={styles.addIconBtn}>
							<AddCircleIcon size={20} />
						</button>
					</div>
					{error && <p className={styles.errorMessage}>{error}</p>}
					{showDropdown && (
						<div ref={dropdownRef} className={styles.dropShow}>
							<div 
								ref={customerListRef}
								className={`${styles.customerList} ${isKeyboardNavActive ? styles.keyboardNavActive : ''}`}
								onScroll={(e) => {
									const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
									if (scrollHeight - scrollTop <= clientHeight + 5 && hasMore && !isListLoading) {
										// Use current search ref and nextCursor for cursor-based pagination
										fetchCustomerList(currentSearchRef.current, nextCursorRef.current);
									}
								}}
							>
								{listFetchError && (
									<p className={styles.errorMessage}>{listFetchError}</p>
								)}
								{(() => {
									// If no search query, show all customers
									if (!searchQuery || !searchQuery.trim()) {
										if (customers.length > 0) {
											return customers.map((customer, index) => (
											<div 
												key={customer.id} 
												className={`${styles.customerItem} ${selectedIndex === index ? styles.selectedCustomerItem : ''}`}
												data-index={index}
												onClick={() => {
													setIsKeyboardNavActive(false);
													handleSelectCustomer(customer.id);
												}}
												onMouseEnter={() => {
													if (!isKeyboardNavActive) {
														setSelectedIndex(index);
													}
												}}
												onMouseMove={() => {
													if (isKeyboardNavActive) {
														setIsKeyboardNavActive(false);
														setSelectedIndex(index);
													}
												}}
											>
													<p>
														{renderSearchHighlight(`${customer.name || ""} ${customer.lastname || ""}`.trim())}
														{renderCustomerMembershipLabel(customer)}
														{renderCustomerBlockedLabel(customer)}
													</p>
													<small>{renderSearchHighlight(customer?.contact_number)}</small>
												</div>
											));
										}
										return null;
									}

									// If search query exists, filter to ensure exact matches
									const exactMatches = filteredCustomers.filter(customer =>
										customer && customerMatchesSearch(customer, searchQuery)
									);
									const addClientIndex = exactMatches.length;

									const listContent = [];

									if (exactMatches.length > 0) {
										listContent.push(...exactMatches.map((customer, index) => (
											<div 
												key={customer.id} 
												className={`${styles.customerItem} ${selectedIndex === index ? styles.selectedCustomerItem : ''}`}
												data-index={index}
												onClick={() => {
													setIsKeyboardNavActive(false);
													handleSelectCustomer(customer.id);
												}}
												onMouseEnter={() => {
													if (!isKeyboardNavActive) {
														setSelectedIndex(index);
													}
												}}
												onMouseMove={() => {
													if (isKeyboardNavActive) {
														setIsKeyboardNavActive(false);
														setSelectedIndex(index);
													}
												}}
											>
												<p>
													{renderSearchHighlight(`${customer.name || ""} ${customer.lastname || ""}`.trim())}
													{renderCustomerMembershipLabel(customer)}
													{renderCustomerBlockedLabel(customer)}
												</p>
												<small>{renderSearchHighlight(customer?.contact_number)}</small>
											</div>
										)));
									}

									// Always show "Add Client" button 
									if (!isListLoading) {
										listContent.push(
											<div
												key="add-new-client-btn"
												className={`${styles.notFoundCustomer} ${selectedIndex === addClientIndex ? styles.selectedCustomerItem : ''}`}
												data-index={addClientIndex}
												onMouseEnter={() => {
													if (!isKeyboardNavActive) {
														setSelectedIndex(addClientIndex);
													}
												}}
												onMouseMove={() => {
													if (isKeyboardNavActive) {
														setIsKeyboardNavActive(false);
														setSelectedIndex(addClientIndex);
													}
												}}
											>
												<PrimaryButton className={styles.fullWidth} text={`Add Client:  ${searchQuery}`} onClick={() => autoFillNewCustomerForm(searchQuery)} />
											</div>
										);
									}

									return listContent;
								})()}
								{isListLoading && <p className={styles.dropdownLoader}>Loading...</p>}

							</div>
						</div>
					)}
				</div>
			)}

			{showNewCustomerForm && (
				<form
					onSubmit={handleCreateCustomer}
					onKeyDown={(e) => {
						if (e.key === 'Enter' && !e.shiftKey) {
							e.preventDefault();
							handleCreateCustomer(e);
						}
					}}
				>
					<div className={styles.halfWidth}>
						<div className={styles.withIcon}>
							<input
								ref={firstnameInputRef}
								type="text"
								value={newCustomer.firstname}
								onChange={(e) => {
									const value = e.target.value || "";
									setNewCustomer({
										...newCustomer,
										firstname: value,
										name: `${value} ${newCustomer.lastname}`.trim(), // Update name field
									});
									validateField("firstname", value);
								}}
								placeholder="First Name"
								className={styles.iconFormControl}
							/>
							{errors.firstname && (
								<div className={styles.errorMessage}>
									{errors.firstname}
								</div>
							)}
							<img src={Usericon} alt="icon" />
						</div>
						<div className={styles.withIcon}>
							<input
								type="text"
								value={newCustomer.lastname}
								onChange={(e) => {
									const value = e.target.value || "";
									setNewCustomer({
										...newCustomer,
										lastname: value,
										name: `${newCustomer.firstname} ${value}`.trim(),
									});
									validateField("lastname", value);
								}}
								placeholder="Last Name"
								className={styles.iconFormControl}
							/>
							{errors.lastname && (
								<div className={styles.errorMessage}>
									{errors.lastname}
								</div>
							)}
							<img src={Usericon} alt="icon" />
						</div>
					</div>
					<div className={styles.withIcon}>
						<div ref={phoneInputWrapperRef} className={`${styles.phoneInputWrapper} ${styles.phoneInputWrapperCustom} hide-default-country-selector`}>
							<CountrySelectorWithSearch
								value={selectedCountry}
								onChange={(country) => {
									// country is now an object with {id, code, name, dial_code, image}
									setSelectedCountry(country);
									const digitsOnly = displayPhoneNumber.replace(/\D/g, '');
									if (digitsOnly && country?.dial_code) {
										const newNumber = `+${country.dial_code}${digitsOnly}`;
										setNewCustomer(prev => ({
											...prev,
											contact_number: newNumber,
											country_id: country.id || null,
										}));
										validateField("contact_number", newNumber);
									} else {
										setNewCustomer(prev => ({
											...prev,
											country_id: country?.id || null,
										}));
									}
								}}
								disabled={false}
							/>
							<div className={styles.phoneInputOnly}>
								<input
									ref={phoneNumberInputRef}
									type="tel"
									value={displayPhoneNumber}
									onKeyDown={(e) => {
										if (e.key === '+' || e.key === '=') {
											e.preventDefault();
										}
									}}
									onKeyPress={(e) => {
										// Allow special keys (Backspace, Delete, Tab, Arrow keys, etc.)
										if (e.key === 'Backspace' || e.key === 'Delete' || e.key === 'Tab' ||
											e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown' ||
											e.ctrlKey || e.metaKey) {
											return;
										}

										// Allow digits (0-9) only — no + or other characters
										if (e.key >= '0' && e.key <= '9') {
											return;
										}

										e.preventDefault();
									}}
									onPaste={(e) => {
										e.preventDefault();
										const pastedText = e.clipboardData.getData('text');

										// Paste with +: detect country and show national digits
										if (pastedText.startsWith('+')) {
											try {
												const phoneNumber = parsePhoneNumber(pastedText);
												if (phoneNumber && phoneNumber.country) {
													updateCountryFromCode(phoneNumber.country);
													setDisplayPhoneNumber(getLocalPhoneDigits(pastedText, phoneNumber));
													setNewCustomer(prev => ({
														...prev,
														contact_number: pastedText,
														country_id: findCountryByCode(phoneNumber.country)?.id || null,
													}));
													validateField("contact_number", pastedText);
													return;
												}
											} catch (err) {
												// If parsing fails, continue with digits-only flow
											}
										}

										// Non-international paste: digits only with selected country
										const digitsOnly = pastedText.replace(/\D/g, '');
										if (digitsOnly) {
											const dialCode = selectedCountry && typeof selectedCountry === 'object'
												? selectedCountry.dial_code
												: getCountryCallingCode(selectedCountry);
											const formattedValue = `+${dialCode}${digitsOnly}`;
											setNewCustomer(prev => ({
												...prev,
												contact_number: formattedValue,
												country_id: prev.country_id || resolveCountryId(selectedCountry),
											}));
											setDisplayPhoneNumber(digitsOnly);
											validateField("contact_number", formattedValue);
										}
									}}
									onChange={(e) => {
										// Digits only — no letters, spaces, or +
										const digitsOnly = e.target.value.replace(/\D/g, '');
										setDisplayPhoneNumber(digitsOnly);

										if (!digitsOnly) {
											setNewCustomer(prev => ({
												...prev,
												contact_number: "",
											}));
											validateField("contact_number", "");
											return;
										}

										const dialCode = selectedCountry && typeof selectedCountry === 'object'
											? selectedCountry.dial_code
											: getCountryCallingCode(selectedCountry);
										const formattedValue = `+${dialCode}${digitsOnly}`;

										setNewCustomer(prev => ({
											...prev,
											contact_number: formattedValue,
											country_id: prev.country_id || resolveCountryId(selectedCountry),
										}));
										validateField("contact_number", formattedValue);
									}}
									placeholder={getMobilePlaceholder(selectedCountry || 'SG')}
									className={`${styles.iconFormControl} ${styles.phoneInputCustom}`}
									style={{ paddingLeft: 0 }}
								/>
							</div>
						</div>
						{errors.contact_number && (
							<div className={styles.errorMessage}>
								{errors.contact_number}
							</div>
						)}
						<img src={Mobileicon} alt="icon" />
					</div>
					<div className={styles.withIcon}>
						<input
							type="email"
							value={newCustomer.email}
							onChange={(e) => {
								const value = e.target.value || "";
								setNewCustomer({
									...newCustomer,
									email: value,
								});
								validateField("email", value);
							}}
							placeholder="Email"
							className={styles.iconFormControl}
						/>
						{errors.email && (
							<div className={styles.errorMessage}>
								{errors.email}
							</div>
						)}
						<img src={Emailicon} alt="icon" />
					</div>

					<div className="d-flex align-items-center button-container sidebar-button-container">
						<BorderedButton
							text="Cancel"
							onClick={() => {
								setShowNewCustomerForm(false);
								const defaultCountry = findCountryByCodeSync("SG");
								setNewCustomer({
									firstname: "",
									lastname: "",
									email: "",
									contact_number: "",
									membership: 0,
									country_id: defaultCountry?.id ?? null,
								});
								setErrors({});
								setError("");
								setApiErrorForCreateBooking?.("");
								setSelectedCountry(defaultCountry || 'SG');
							}}
						/>
						<PrimaryButton
							text={isCreatingCustomer ? "Processing..." : "Create"}
							type="submit"
							disabled={isCreatingCustomer}
						/>
					</div>
				</form>
			)}

			{selectedCustomer && (
				<>
					<div className={styles.customerInfo}>
						<div className={styles.showCustomerInfo}>
							<div
								className={styles.customerDetail}
								onClick={(e) => {
									// Prevent navigation if clicking on the delete button area
									if (e.target.closest(`.${styles.delIconBtn}`)) {
										return;
									}
									// Stop event propagation to prevent triggering discard popup
									e.stopPropagation();
									if (preventChanges && typeof onLockedEditClick === 'function') {
										onLockedEditClick();
										return;
									}
									// Dispatch custom event to open customer details modal instead of navigating
									if (selectedCustomer) {
										const event = new CustomEvent('openCustomerDetails', {
											detail: { customer: selectedCustomer }
										});
										window.dispatchEvent(event);
									}
								}}
								style={{ cursor: 'pointer' }}
							>
								<div className={styles.customerInitials} style={{backgroundColor: getConsistentColor(selectedCustomer.id, selectedCustomer.name)}}>
									{getInitials(`${selectedCustomer.name || ""} ${selectedCustomer.lastname || ""}`.trim())}
									{Number(selectedCustomer.membership) === 1 && (
										<span className={styles.membershipIcon}>
											<PrimiumMemberIcon />
										</span>
									)}
								</div>
								<div>
									<p className={`mt-3 ${styles.customerPhone}`}>
										{selectedCustomer.contact_number || ""}
									</p>
									<h5 className={styles.customerName}>
										{selectedCustomer.name} {selectedCustomer.lastname || ""}
									</h5>

								</div>
							</div>
							{!preventChanges && (	
							<div
								className={`${styles.delIconBtn} icon`}
								onClick={(e) => {
									e.stopPropagation();
									handleDeleteCustomer();
								}}
							>
								<TrashIcon />
							</div>
							)}
						</div>

						{!hideTagging && (
						<TaggingDropdown
							selectedLabel="Not Tagged"
							selectedOption={selectedGuestCheckin}
							onSelect={(user) => handleSelectGuestCheckin && handleSelectGuestCheckin(user, 'customer')}
							onDropdownToggle={handleGetGuestCheckinList}
							options={guestCheckinList}
							placeholder="Search name"
							guestCheckinRemoteList={guestCheckinRemoteList}
							onGuestCheckinSearchQueryChange={onGuestCheckinSearchQueryChange}
							onGuestCheckinLoadMore={onGuestCheckinLoadMore}
							guestCheckinHasMore={guestCheckinHasMore}
							guestCheckinLoadingMore={guestCheckinLoadingMore}
						/>
						)}

						<div className={styles.membershipRequired}>
							{showMembershipToggle && (
							<label
								className={`${styles.toggleLabel} ${isMembershipToggleDisabled ? styles.disabledToggle : ''}`}
								onClick={preventChanges ? onLockedEditClick : undefined}
							>
								<span className={styles.labelText}>Apply membership discount:</span>
								<label className={styles.switch}>
									<input
										type="checkbox"
										checked={membershipToggleBlocked ? false : isMembershipApplied}
										disabled={preventChanges}
										onChange={(e) => {
											if (membershipToggleBlocked) {
												e.preventDefault();
												setIsMembershipApplied(false);
												onMembershipToggleBlocked?.();
												return;
											}
											const isChecked = e.target.checked;
											const newValue = isChecked ? 1 : 0;

											setIsMembershipApplied(isChecked);

											setItemData((prev) => ({
												...prev,
												membership: Number(newValue),
											}));

											if (editableBooking) {
												setEditedItemData((prev) => ({
													...prev,
													membership: Number(newValue),
												}));
											}
											setIsMembershipChange(true);
										}}
									/>
									<span className={styles.slider}></span>
								</label>
							</label>
							)}
							{customerNotes?.trim() && (
								<div className={styles.customerNotes}>
									<p className={styles.customerNotesText}>
										{customerNotes}
									</p>
								</div>
							)}
						</div>
					</div>
					{error && <p className={styles.errorMessage}>{error}</p>}
				</>
			)}
		</>
	);
};

export default CustomerSelector;
